export const getProjectListPagination = (state) => state.getIn(['ui', 'projectList', 'pagination']);

export const getProjectForm = (state) => state.getIn(['ui', 'projectList', 'form']);

export const getProjectListDataset = (state) => state.getIn(['ui', 'projectList', 'dataset']);
